(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelAvailability', HotelAvailability);

function HotelAvailability(pagingService,
            urlUtils,
            preferences,
            basketStore,
            breadcrumbDetailsService,
            tripService,
            occupancyService,
            scrollService,
            $route,
            $scope,
            arrayUtil,
            $rootScope,
            $location,
            $window,
            hotelSearch,
            reviewService,
            shortlistService,
            cookieService,
            hotel,
            hotelResolver,
            flightSearch,
            authService,
            bd4travel,
            broker,
            basketService,
            $routeParams,
            $timeout,
            resourceService,
            searchUnitService,
            analytics,
            criteoService,
            currentDestination,
            destinationService,
            taxationService,
            currencyService,
            $q,
            $filter,
            bookedEstabId,
            $anchorScroll,
            mandatoryTransferService,
            hotelRoomService) {
    if (hotel == null) { return; }

    this.bookedEstabId = bookedEstabId;

    if ($routeParams.shortlist) {
        shortlistService.addToShortlist(hotel)
            .then(function() {
                authService.bufferRoute(null);  //clear any buffered route that might be left behind
                $location.search('shortlist', null);
            });
        return;
    }

    if (_.get($location.search(), 'source') != null) {
        this.isMeta = true;
    }

    if (_.get($location.search(), 'source') === 'TV') {
        $(window).one('click', () => {
            window.moveTo(0, 0);
            window.resizeTo(screen.availWidth, screen.availHeight);
        });
    }

    scrollTo(0, 0);
    $rootScope.unlockScreen($scope);
    analytics.startTimer(hotel.Title);


    const cm = this;
    const filter = angular.copy(hotelSearch.getFilter());
    let boardTypeFilterSet = hotelSearch.filterSet('BoardTypes');
    let showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
    const deferredFlightCost = $q.defer();
    const deferredLowDepositValue = $q.defer();
    const deferredCurrency = $q.defer();
    const deferredFlight = $q.defer();
    const deferredRules = $q.defer();

    function isPriceModeInLocation(location) {
        return location.priceMode != null;
    }

    function setPriceMode(p, location) {
        if (isPriceModeInLocation(location) && TRPCONFIG.Domain.PriceModeUrlHash) {
            cm.priceMode = parseFloat(location.priceMode);
        } else {
            cm.priceMode = p;
        }
    }

    preferences.get('priceMode').then(function(p) {
        setPriceMode(p, $location.search());
    });

    cm.scrollToReviews = scrollToReviews;
    cm.scrollToRooms = scrollToRooms;
    cm.hideRooms = true;
    cm.activeHotel = angular.copy(hotel);
    cm.hotel = hotel;
    cm.isMobileDevice = TRPCONFIG.IsMobileDevice;
    cm.isMultiDestHoliday = false;
    cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
    cm.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
    cm.longSpecialOfferText = '';
    broker.publish('hotelViewed', cm.hotel);

    // Isolate hotel facilites
    cm.hotelFacilities = _.find(cm.hotel.FacilityGroups, fg => {
        return fg.name = 'Facilities';
    });

    /*
     * Setter for cm.hotel.LowDepositValueWithFlight
     */
    function setLowDepositValueWithFlight(promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules) {
        $q.all([promiseFlightCost, promiseLowDepositValue, promiseCurrency, promiseFlight, promiseRules]).then(data => {
            const roundedCurrencyFilter = $filter('roundedCurrency');
            const unformattedString = $filter('unformattedString');
            const flightCost = data[0];
            const lowDepositeValue = data[1];
            const currency = data[2];
            const flight = data[3];
            const rules = data[4];

            let flightDeposite = 0;
            const flightDepositeAllowed = rules.depositAllowed;

            if (flight != null) {
                flightDeposite = flight.ImmediatePayment.Amount;
            }

            const lowDepositeAndFlightDeposite = flightDeposite + lowDepositeValue;
            const lowDepositeAndFlightCost = flightCost + lowDepositeValue;
            const lowDepositeValueFormated = roundedCurrencyFilter(lowDepositeValue, currency);

            const LOWDEPOSITEHOLIDAY = resourceService.get('LOWDEPOSIT:HOLIDAY');
            const LOWDEPOSITEFLIGHT = resourceService.get('LOWDEPOSIT:FLIGHT');

            const LOWDEPOSITPACKAGEHOLIDAY = resourceService.get('LOWDEPOSITPACKAGEHOLIDAY');

            function getLowDepositeAndFlightCostText() {
                const roundedCost = roundedCurrencyFilter(lowDepositeAndFlightCost, currency);
                return unformattedString(LOWDEPOSITEHOLIDAY, roundedCost, lowDepositeValueFormated);
            }

            function getLowDepositeAndFlightDepositeText() {
                const roundedCost = roundedCurrencyFilter(lowDepositeAndFlightDeposite, currency);
                return unformattedString((cm.packagePrice ? LOWDEPOSITPACKAGEHOLIDAY : LOWDEPOSITEFLIGHT), roundedCost, lowDepositeValueFormated);
            }

            cm.hotel.lowDepositText = flightDepositeAllowed ?
                getLowDepositeAndFlightDepositeText() :
                getLowDepositeAndFlightCostText();
        });
    }

    setLowDepositValueWithFlight(deferredFlightCost.promise, deferredLowDepositValue.promise, deferredCurrency.promise, deferredFlight.promise, deferredRules.promise);

    cm.loadingReviews = false;
    cm.loadingFirstReviews = false;
    cm.setTab = setTab;
    cm.mapTab = mapTab;
    cm.reviewsTab = reviewsTab;
    cm.photosTab = photosTab;
    cm.search = search;
    cm.selectRooms = selectRooms;
    cm.showAllRooms = false;
    cm.tab = 'detail';
    cm.tabClass = tabClass;
    cm.toggleShortlist = toggleShortlist;
    cm.roomsLeftLimit = TRPCONFIG.Domain.UrgencyMessageRoomThreshold;
    cm.roomAvailability = getRoomAvailability;
    cm.changeHotel = changeHotel;
    cm.isHoliday = $route.current && $route.current.area === 'holidays';
    const pi = $location.search().pi;
    cm.paging = pagingService.data(pi == null ? 1 : parseInt(pi) + 1, 10, cm.hotel.CustomerReviewCount);
    cm.pageReviews = TRPCONFIG.Domain.ReviewsEnabled ? _getReviews : null;

    cm.showSearchUnit = _showSearchUnit();
    cm.toggleSearchUnit = toggleSearchUnit;
    cm.topHotelRoomHasSpecialOffer = topHotelRoomHasSpecialOffer;
    cm.getTopHotelRoomSpecialOffer = getTopHotelRoomSpecialOffer;

    tripService.usePackageRates().then(packagePrice => cm.packagePrice = packagePrice);

    tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(numNights => cm.numNights = numNights);
    tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(ds => {
                    cm.durationSummary = ds;
                    cm.searchSummary = ds ? `${ds}, ${hotelSearch.getOccupancySummary()}` : '';
    });
    currentDestination.getCurrentDestination().then(dest => cm.destination = dest);

    broker.subscribe('HotelAvailability', 'boardTypeFilterUpdated', function(ev) {
        boardTypeFilterSet = ev.data != null && ev.data.length > 0;
        showRoomPredicate = boardTypeFilterSet ? _matchesBoardTypeFilter : _isShortlisted;
        filter.BoardTypes = ev.data;
        _setRooms();
    });

    broker.subscribe('HotelAvailability', 'priceModeChanged', function(ev) {
        if (isPriceModeInLocation(location) && TRPCONFIG.Domain.PriceModeUrlHash) {
            $location.search('priceMode', ev.data).replace();
            $anchorScroll('#rooms-grid');
        }
        cm.priceMode = ev.data;
    });

    broker.subscribe('HotelAvailability', 'hotelDetailCallFailed', function(ev) {
        cm.showSpinner = null;
        analytics.track('mixpanel', 'SupplierDetailError', {
            estabId: ev.data.EstabId
        });

        //When the hotel details call fails for any reason, we are assuming that the room is sold out
        cm.hotelDetailsFailed = true;
        _.forEach(cm.hotel.Rooms[0].Availability, room => {
            if (room.Id === ev.data.RoomAndBoardIds[0]) {
                room.soldOut = true;
            }
        });
        broker.publish('roomsSet', cm.hotel);

        $rootScope.unlockScreen($scope);
        $timeout(() => scrollService.scrollTo('#roomsPanel'), 100);
    });

    broker.subscribe('HotelAvailability', 'continueToBookFromFlightDetailsModal', function(e) {
        continueToBook(e.data.priceId);
    });

    if (TRPCONFIG.Domain.ShortlistsEnabled) {
        shortlistService.isHotelShortlisted(cm.hotel).then(function(inList) {
            cm.hotelInShortlist = inList;
        });
    }

    $scope.$watch('cm.tab', function() {
        $rootScope.$emit('hideCloseButton');
    });

    angular.forEach(['detail'], function(val) {
        cm[`${val}Tab`] = function() {
            cm.setTab(val);
        };
    });

    //call the hotel resolver again and this time make sure we ask for the rooms as well
    $timeout(() => scrollService.scrollTo(scrollService.getScrollTarget()), 500);
    const includeRooms = true;
    hotelResolver.resolve(includeRooms)
        .then(h => {
            broker.publish('hotelCacheReady', h);
            bd4travel.trackHotelAvailability($routeParams.tripId, hotel.Id, 'productDetails');
            if (h.LowDepositValue) {
                deferredLowDepositValue.resolve(h.LowDepositValue);
            }
            // Update hotel with all dest params
            destinationService.getDetails(h)
                .then(dest => cm.hotelDestination = dest)
                .then(() => {
                    cm.hotel = h;
                    _setRooms();
                    cm.hideRooms = false;
                });
    });

    const locSearch = $location.search();
    switch (locSearch.pd) {
        case 'mp':
            $timeout(function() { cm.mapTab(); });
            break;
        case 'rv':
            cm.reviewsTab();
            if (locSearch.lr) {
                reviewService.likeReview.organic(locSearch.lr, true);
            }
            break;
        case 'ph':
            cm.photosTab();
            break;
    }

    if (TRPCONFIG.DeviceSettings.AutoLoadReviews && locSearch.pd !== 'rv' && TRPCONFIG.Domain.ReviewsEnabled) {
        reviewsTab();
    }

    broker.subscribe('HotelAvailability', 'roomSearchStarted', function hideRooms() {
        cm.hideRooms = true;
    });

    broker.subscribe('HotelAvailability', 'roomSearchEnded', function hideRooms() {
        cm.hideRooms = false;

        cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function(r) {
            r.selected = r.Availability[0].Id;
            return r;
        });
        tripService.getHotelsRequestNumberOfNights($routeParams.tripId).then(numNights => cm.numNights = numNights);
        scrollService.scrollTo('#roomsPanel');
        _setRooms();
    });

    cm.isHotelFirstJourney = basketService.isFlightPreselected();

    function _setRooms() {
        cm.allRoomsAvailable = true;
        cm.currencyCode = searchUnitService.getCurrency();
        if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0) {
            cm.hotel.Rooms = arrayUtil.map(cm.hotel.Rooms, function(r, i) {
                if (boardTypeFilterSet) {
                    r.FilteredAvailability = arrayUtil.filter(r.Availability, _matchesBoardTypeFilter);
                    if (r.FilteredAvailability.length > 0) {
                        r.selected = r.FilteredAvailability[0].Id;   //overwrite the preselected room becuase it may have been filtered out
                    } else {
                        cm.allRoomsAvailable = false;
                    }
                } else {
                    r.FilteredAvailability = r.Availability;
                }

                r.isRoomKidsFree = occupancyService.isRoomKidsFree(i) && cm.isKidsFree;
                r.nonInfants = r.isRoomKidsFree
                    ? occupancyService.getOnlyAdultsPerRoom(i)
                    : occupancyService.getNumberOfNonInfantsForRoom(i);
                return r;
            });
            cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
            const currentFbt = $location.search() && $location.search().fbt;
            if (currentFbt) {
                const multipleBoardTypes = [...currentFbt];
                cm.lowestPriceBoardType = findLowestBoardDescLabel(cm.hotel.Rooms[0].Availability, multipleBoardTypes);
            } else {
                cm.lowestPriceBoardType = lowestPriceBoardType(cm.hotel.Rooms[0].Availability);
            }

            $timeout(() => broker.publish('roomsSet', cm.hotel));
        }

        //find out how many other hotels the user can look through if we dont have any availability for the current hotel
        if ((cm.hotel.Rooms == null || cm.hotel.Rooms.length === 0) && $routeParams.tripId) {
            tripService.getTrip($routeParams.tripId).then(trip => {
                hotelSearch.getSearchResults(trip.HotelsRequest.AvailabilitySearchId, { ignoreTracking: true }).then(data => {
                    cm.HotelCount = data.Aggregates.HotelCount;
                    cm.LowestPricedHotel = data.Aggregates.LowestPricedHotel;
                    cm.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
                    analytics.trackEvent({ category: 'hotelResultsPage', action: 'noRates', label: 'no hotel availability message' });
                });
            });
        }

        //this calculates the total number of room availability for all rooms
        const totalRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function(rr) { return rr.FilteredAvailability.length; }))) : 0;
        const defaultMax = cm.hotel.Rooms ? 5 * cm.hotel.Rooms.length : 5;

        //this calculates the number of rooms that should be shown according to the showRoomPredicate
        let maxRooms = cm.hotel.Rooms ? (arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(cm.hotel.Rooms, function(rr) {
            return arrayUtil.filter(rr.FilteredAvailability, showRoomPredicate).length;
        }))) : 0;

        if (maxRooms > defaultMax) {
            maxRooms = defaultMax;
        }

        cm.moreRooms = cm.hotel.Rooms ? (totalRooms - maxRooms) : 0;

        if (cm.hotel.Rooms) {
            cm.roomLimit = function(r) {
                return cm.showAllRooms || showRoomPredicate(r);
            };

            cm.toggleExtraRooms = function() {
                if (cm.showAllRooms) {
                    scrollService.scrollTo('#roomsPanel', { animate: true }).then(function() {
                        cm.showAllRooms = !cm.showAllRooms;
                    });
                } else {
                    cm.showAllRooms = !cm.showAllRooms;
                }
            };

            cm.longSpecialOfferText = getTopLongSpecialOfferText();

            updateRibbons(cm.hotel);
        }

        if (TRPCONFIG.Domain.EnableCityTax && cm.hotel.IsCityTaxIncludedInPrice) {
            cm.cityTax = {};
            if (cm.hotel.Rooms != null && cm.hotel.Rooms.length > 0
                && cm.hotel.Rooms[0].Availability && cm.hotel.Rooms[0].Availability.length > 0) {
                cm.cityTax.TotalAmount = cm.hotel.Rooms[0].Availability[0].CityTax;
                cm.cityTax.CityTaxLocalAmount = cm.hotel.Rooms[0].Availability[0].CityTaxLocalAmount;
                cm.cityTax.CurrencyCode = cm.hotel.Rooms[0].Availability[0].CityTaxLocalCurrency;
            }
        }

        cm.mandatoryExtras = hotelSearch.getMandatoryExtra(cm.hotel);

        $timeout(function() {
            scrollService.scrollTo(scrollService.getScrollTarget());
        }, 500);

        analytics.endTimer(cm.hotel.Title);
    }


    function _getReviews(page, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        cm.loadingReviews = true;
        if (page === 1) {
            cm.loadingFirstReviews = true;
        }
        reviewService.getReviews(cm.hotel, page - 1).then(function(result) {
            cm.reviews = result.reviews;
            cm.loadingReviews = false;
            cm.loadingFirstReviews = false;
            cm.paging = pagingService.data(page, 10, cm.hotel.CustomerReviewCount);
        });
    }

    function _matchesBoardTypeFilter(b) {
        return arrayUtil.indexOf(filter.BoardTypes, function(bt) {
                return parseInt(bt) === b.BoardType;
        }) >= 0;
    }

    function _isShortlisted(b) {
        return b.IsShortlisted;
    }

    function getRoomAvailability() {
        if (cm.hotel.Rooms.length === 1) {
            return cm.hotel.Rooms[0].Availability.length;
        }

        if (cm.hotel.Rooms.length > 1) {
            let roomOptions = 0;

            angular.forEach(cm.hotel.Rooms, function(room) {
                roomOptions += room.Availability.length;
            });

            return roomOptions;
        }
    }

    function _showSearchUnit() {
        let showSearchUnit;
        if (TRPCONFIG.Domain.SearchUnitExpandedForMeta && cm.isMeta) {
            showSearchUnit = (TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone') || cm.isMeta;
        } else {
            showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
        }
        return showSearchUnit;
    }

    function toggleShortlist() {
        shortlistService.toggleHotel(cm.hotel).then(function(inShortlist) {
            cm.hotelInShortlist = inShortlist;
        });
    }

    function tabClass(tab) {
        if (tab instanceof Array) {
            return tab.indexOf(cm.tab) >= 0 ? 'active' : '';
        }
        return tab === cm.tab ? 'active' : '';
    }

    function scrollToRooms() {
        scrollService.scrollTo('#roomsPanel', { animate: true });
        analytics.trackEvent({ label: 'scroll to rooms grid' });
    }

    function scrollToReviews() {
        reviewsTab();
        scrollService.scrollTo('#reviewsSection', { animate: true });
    }

    function setTab(tab) {
        if (cm.tab !== tab) {
            cm.tab = tab;
        }
    }

    function reviewsTab() {
        cm.setTab('reviews');
        cm.reviews = [];
        _getReviews(cm.paging.page);
    }

    function photosTab() {
        cm.setTab('photos');
    }

    function mapTab() {
        cm.setTab('map');
        $scope.$broadcast('mapTabSelected');
    }

    function _chosenRooms() {
        return arrayUtil.map(arrayUtil.filter(cm.hotel.Rooms, function(rr) { return rr.selected != null; }), function(rr) {
            return rr.selected;
        });
    }

    function selectRooms(roomIds, room) {
        if (!roomIds) {
            roomIds = _chosenRooms();
        }

        if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !cm.isHoliday && (roomIds.length > 1 || room)) {
            checkOnMandatoryTransfers(roomIds);
        } else {
            continueToBook(roomIds);
        }
    }

    function continueToBook(roomIds) {
        const { tripId } = $routeParams;

        cookieService.set('VoucherCode', '');
        cookieService.set('VoucherWarnMessage', '');
        cookieService.set('SelectedPrices', roomIds || '');

        try {
            analytics.track('Event', 'SelectHotelRoom', {
                Revenue: cm.hotel.MinCost,
                HotelTitle: cm.hotel.Title
            });
        } catch (err) {}

        if (roomIds == null) {
            roomIds = _chosenRooms();
        }
        cm.showSpinner = roomIds[0];
        $rootScope.lockScreen($scope, {
            title: resourceService.get('PREPARINGBOOKING'),
            loadingScreenStyle: 'booking-hotelAvailabilityCtrl'
        });
        analytics.track('mixpanel', 'HotelDetailClick', {
            AwardClicked: !!_.get(hotel, 'AwardDetails')
        });

        if (cm.isMultiDestHoliday) {
            return tripService.getTrip(tripId)
                .then(() => basketService.selectHotelRooms(cm.hotel, roomIds, tripId))
                .then(() => tripService.changeTripType(tripId, tripService.tripTypes.Holiday));
        }
        return basketService.selectHotelRooms(cm.hotel, roomIds, tripId);
    }

    function checkOnMandatoryTransfers(roomIds) {
        if (!roomIds) {
            roomIds = _chosenRooms();
        }

        const roomGridData = hotelRoomService.restructureData(cm.hotel);
        let selectedPrices = {};
        for (let i = 0; i < roomIds.length; i++) {
            selectedPrices[`id${i}`] = roomIds[i];
        }
        const rooms = mandatoryTransferService.getRoomsWithTransfers(cm.hotel, roomGridData, selectedPrices);
        if (rooms.length > 0) {
            const priceMode = cm.priceMode;
            broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms, priceMode });
        } else {
            continueToBook(roomIds);
        }
    }

    function search() {
        basketService.startWorkflow(basketService.hotelBooking).then(null, function(errors) {
            $scope.$emit('flash:error', errors);
        });
    }

    function changeHotel() {
        if (cm.isMultiDestHoliday) {
            $location.url(`/holidays/january-sale/${$routeParams.tripId}`);
            return;
        }
        if ($routeParams.tripId && $route.current.area) {
            if (cm.dealsMode) {
                tripService.getTrip($routeParams.tripId).then(trip => {
                    if (trip && trip.Deal) {
                        $location.url(urlUtils.stripLeadingSlash(trip.Deal.OriginPath));
                    }
                });
            } else {
                tripService.setDirectToHotel($routeParams.tripId, false).then(function() {
                    let nextUrl = $routeParams.BookingRef ?
                        `dashboard/amend-booking/${$routeParams.BookingRef}/${$routeParams.BookingId}/${$routeParams.tripId}` :
                        `${$route.current.area}/${$route.current.area === 'holidays' ? 'hotels/' : ''}${$routeParams.tripId}`;
                    $location.path(nextUrl);
                });
            }
        }
    }

    function toggleSearchUnit() {
        cm.showSearchUnit = !cm.showSearchUnit;
    }

    function getTopHotelRoomSpecialOffer() {
        return {
            offerText: _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', ''),
            roomType: _.get(cm, 'hotel.Rooms[0].Availability[0].RoomDescription', '')
        };
    }

    function topHotelRoomHasSpecialOffer() {
        return _.get(cm, 'hotel.Rooms[0].Availability[0].LongSpecialOfferText', '').trim() !== '';
    }

    function getTopLongSpecialOfferText() {
        const rooms = cm.hotel.Rooms[0] || [];
        let text = '';

        _.forEach(rooms.Availability, availability => {
            if (availability.LongSpecialOfferText) {
                text = availability.LongSpecialOfferText;
                return false;
            }
        });

        return text;
    }

    function lowestPriceBoardType(arr) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].IsCheapest) {
                return arr[i].BoardDescription;
            }
        }
    }

    function findLowestBoardDescLabel(arr, fbt) {
       if ((!fbt || fbt.length === 0) && (!arr || arr.length === 0)) { return; }

        const filtered = arr.filter(room => {
            return fbt.indexOf(room.BoardType) !== -1;
        });

        const [cheapestPrice] = sortBoardTypes(filtered);
        return cheapestPrice && cheapestPrice.BoardDescription;
    }

    function sortBoardTypes(arr) {
        return arr.sort((a, b) => a.Cost >= b.Cost ? 1 : -1);
    }

    function makeRibbonStyles(overlay) {
        const pillPrefix = 'sc-c-pill';
        const textPrefix = 'u-text';
        const pillStyle = [pillPrefix, `${pillPrefix}--${overlay.ColourClass}`];
        const promoTextStyle = [`${textPrefix}--${overlay.ColourClass}`];
        overlay.EffectClasses.forEach(effect => {
            pillStyle.push(`${pillPrefix}--${effect}`);
            promoTextStyle.push(`${textPrefix}--${effect}`);
        });

        return {
            pillClass: pillStyle.join(' '),
            promoTextClass: promoTextStyle.join(' ')
        };
    }

    function updateRibbons(hotel) {
        hotel.Rooms.forEach(room => {
            room.Availability.forEach(item => {
                if (item.OverlayNew) {
                    const appliedToAllRooms = room.Availability.every(board => {
                        return (hotel.PromotionRibbon && hotel.PromotionRibbon.Text) === (board.OverlayNew && board.OverlayNew.Text);
                    });
                    if (!appliedToAllRooms) {
                        const styles = makeRibbonStyles(item.OverlayNew);
                        const textSeparator = getSeparator(item.OverlayNew.Text);

                        item.pillClass = styles.pillClass;
                        item.promoTextClass = styles.promoTextClass;
                        item.promotionText = item.OverlayNew.Text.toUpperCase()
                                                                            .split(textSeparator)
                                                                            .map(textLengthValidator);
                    }
                }
            });
        });
    }

    function getSeparator(ribbonText) {
        return ribbonText && ribbonText.includes('|') ? '|' : ' ';
    }

    function textLengthValidator(text) {
        return text && text.slice(0, 10);
    }

    if ($routeParams.tripId) {
        tripService.getCurrency($routeParams.tripId).then(cur => {
            deferredCurrency.resolve(cur);
            cm.currencyCode = cur;
        });
        tripService.getTrip($routeParams.tripId).then(function(trip) {
            criteoService.enqueue(cm.hotel, 'hotel', trip.TripType);
            analytics.track('mixpanel', 'HotelPage');
            analytics.track('Event', 'HotelChanged', {
                Hotel: cm.hotel,
                Flight: trip.FlightsRequest ? trip.FlightsRequest : null
            });
            analytics.track('Facebook', 'HotelPage');

            cm.hotelAvailabilitySearchId = _.get(trip, 'HotelsRequest.AvailabilitySearchId');
            cm.isMultiDestHoliday = trip.TripType === tripService.tripTypes.MultiDestHoliday;
            cm.isKidsFree = trip.IsKidsFree &&
                (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);

            if (cm.isKidsFree) {
                cm.payingIndividuals = occupancyService.getOnlyPayingIndividuals();
            }

            const numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
            basketStore.rules(trip.BasketId).then(data => {
                deferredRules.resolve(data);
            });
            basketStore.flight(trip.BasketId).then(data => { //TODO Rewrite for flightCost
                deferredFlight.resolve(data);
            });
            basketStore.flightCost(trip.BasketId).then(c => {
                deferredFlightCost.resolve(c);
                cm.totalFlightCost = c;
                cm.flightCostPerPerson = c / numPassengers;
                cm.marhabaCost = 0;

                if (cm.packagePrice && TRPCONFIG.Domain.MarhabaEnabled) {
                    basketStore.marhabaCost(trip.BasketId).then(cost => {
                        cm.marhabaCost = cost || 0;
                        return cost;
                    });
                }

                //make sure we don't set this up until the flight costs are available
                cm.holidayPriceByMode = function(hotelPrice, roomNonInfants, marhabaCost = 0) {
                    const payingNum = cm.isKidsFree ? cm.payingIndividuals : roomNonInfants;
                    if (cm.priceMode === 0) {
                        return hotelPrice / payingNum + cm.flightCostPerPerson + (marhabaCost / payingNum);
                    }
                    if (cm.priceMode === 1) {
                        return hotelPrice + (marhabaCost + cm.totalFlightCost * (roomNonInfants / cm.nonInfants));
                    }
                };
            });
        });
    }

    $scope.$on('$destroy', function() {
        broker.unsubscribe('HotelAvailability');
    });

}
})();
